module.exports = __webpack_public_path__ + "static/media/zoom_out_off.41ac4b5d.svg";